var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.isDynamicPanel)?_c('div',_vm._l((_vm.activePage.elements.filter(
      (m) =>
        m.dynamicPanelUUID == _vm.item.uuid &&
        _vm.item.states[0].uuid == m.dynamicPanelStateUUID
    )),function(i,k){return _c(i.elName,_vm._b({key:k,tag:"component",staticClass:"element-on-edit-pane",style:(_vm.getCommonStyle({
        ...(i.isHotZone
          ? { ...i.commonStyle, background: 'rgba(255,255,0,0.1)' }
          : i.isDynamicPanel
          ? { ...i.commonStyle, background: 'rgba(109,0,255,0.1)' }
          : i.commonStyle),
      }))},'component',i.propsValue,false),[(i.isDynamicPanel)?_c('dynamic-panel-self',{attrs:{"item":i}}):_vm._e()],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }